<ng-container *transloco="let t">
<section *appHasAnyPrivilege="'DASHBOARD.VIEW'">
  <div
    *ngIf="getStartedMetrics?.isShowBanner"
    class="w-full rounded-xl border border-[#E5E7EB] bg-[#F9FAFB] overflow-hidden mb-4 relative">
    <button
      (click)="closeBanner()"
      class="absolute right-3 top-3 text-[#9CA3AF] hover:text-[#6B7280] cursor-pointer z-10">
      <span nz-icon nzType="close"></span>
    </button>
    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4">
      <div
        *ngFor="let step of steps; let last = last; let i = index"
        class="flex items-start gap-3 px-6 py-5 relative">
        <div
          class="w-10 h-10 rounded-full flex items-center justify-center"
          [ngClass]="step.iconBg">
          <span nz-icon [nzType]="step.icon" [ngClass]="step.iconColor"></span>
        </div>

        <div class="flex-1 min-w-0">
          <h3 class="text-[14px] font-semibold text-[#1F2937] mb-1">
            {{ step.title }}
          </h3>

          <p class="text-[12px] leading-[18px] text-[#6B7280] mb-2">
            {{ step.description }}
          </p>

          <span *ngIf="i === 0" class="text-[12px] font-medium text-[#7C3AED]">
            {{ completionCount }}/{{ by }} {{ t('dashboard.getStarted.completed') }}
          </span>
          <a
            *ngIf="step.action"
            (click)="handleAction(step.actionKey)"
            class="inline-flex items-center gap-1 text-[12px] font-medium text-[#7C3AED] hover:text-[#6D28D9] cursor-pointer">
            {{ step.action }}
            <span nz-icon nzType="arrow-right"></span>
          </a>
        </div>

        <div
          *ngIf="!last"
          class="hidden xl:block absolute right-0 top-4 bottom-4 w-px bg-[#E5E7EB]"></div>
      </div>
    </div>
  </div>

  <nz-card class="mb-8 bg-slate-100 rounded-xl">
    <div class="flex justify-between items-center">
      <div class="">
        <nz-page-header-title
          class="max-[563px]:w-64 text-primary flex items-center gap-2">
          {{ t('dashboard.title') }}
          <nz-icon
            nz-tooltip
            nzTooltipPlacement="right"
            [nzTooltipArrowPointAtCenter]="true"
            [nzTooltipTitle]="'nav.featureTooltips.dashboard' | transloco"
            [nzTooltipOverlayStyle]="{
              'max-width': '400px',
              'min-width': '300px',
              'white-space': 'normal',
              'line-height': '1.5'
            }"
            nz-icon
            nzType="info-circle"
            nzTheme="outline">
          </nz-icon>
        </nz-page-header-title>
        <p>
          {{ t('dashboard.from') }} <span class="text-base font-bold">{{ this.startDate }}</span> {{ t('dashboard.to') }}
          <span class="text-base font-bold">{{ this.endDate }}</span>
        </p>
      </div>
      <div class="flex xl:flex-row flex-wrap justify-end gap-5">
        <nz-range-picker
          [nzRanges]="ranges"
          [nzFormat]="dateFormat"
          [(ngModel)]="dateRange"
          (ngModelChange)="onDateChange($event)"></nz-range-picker>
      </div>
    </div>
  </nz-card>

  <nz-card
    *appHasAnyPrivilege="'DASHBOARD.COUNT.VIEW'"
    class="bg-slate-100 rounded-xl">
    <div class="grid sm:grid-cols-3">
      <div class="grid justify-center my-2">
        <div class="flex items-center">
          <div
            class="w-20 h-20 rounded-full overflow-hidden bg-[#EBDCFFFF] bg-opacity-40 grid items-center justify-center">
            <span
              nz-icon
              nzType="file"
              [nzTheme]="'twotone'"
              [nzTwotoneColor]="'#6911D8'"
              style="font-size: 24px"></span>
          </div>
          <div class="text-start ml-5">
            <p class="text-sm font-normal">{{ t('dashboard.itineraryCreated') }}</p>
            <h3 class="text-[#6911D8]">
              {{ this.itineraryCount?.itineraryCount }}
            </h3>
          </div>
        </div>
      </div>
      <div class="grid justify-center my-2">
        <div class="flex items-center">
          <div
            class="w-20 h-20 rounded-full overflow-hidden bg-[#FFE3D6FF] bg-opacity-70 grid items-center justify-center">
            <span
              nz-icon
              nzType="check-circle"
              [nzTheme]="'twotone'"
              [nzTwotoneColor]="'#FB8544'"
              style="font-size: 24px"></span>
          </div>
          <div class="text-start ml-5">
            <p class="text-sm font-normal">{{ t('dashboard.itinerariesSent') }}</p>
            <h3 class="text-[#FB8544]">
              {{ this.itineraryCount?.sentItineraryCount }}
            </h3>
          </div>
        </div>
      </div>
      <div class="grid justify-center my-2">
        <div class="flex items-center">
          <div
            class="w-20 h-20 rounded-full overflow-hidden bg-[#C2FFE0FF] bg-opacity-40 grid items-center justify-center">
            <span
              nz-icon
              nzType="dollar-circle"
              [nzTheme]="'twotone'"
              [nzTwotoneColor]="'#27B46A'"
              style="font-size: 24px"></span>
          </div>
          <div class="text-start ml-5">
            <p class="text-sm font-normal">{{ t('dashboard.itinerariesConverted') }}</p>
            <h3 class="text-[#27B46A]">
              {{ this.itineraryCount?.salesConvertCount }}
            </h3>
          </div>
        </div>
      </div>
    </div>
  </nz-card>

  <div class="grid md:grid-cols-2 gap-5 my-8">
    <nz-card
      *appHasAnyPrivilege="'DASHBOARD.ITINERARIES.VIEW'"
      class="bg-slate-100 rounded-xl p-8">
      <h5 class="mb-12 text-primary">{{ t('dashboard.latestItineraries') }}</h5>
      <ng-container *ngIf="this.itineraries.length === 0">
        <nz-empty></nz-empty>
      </ng-container>
      <ng-container *ngIf="this.itineraries.length !== 0">
        <div *ngFor="let itin of itineraries">
          <div
            class="flex flex-col lg:flex-row items-center justify-center lg:justify-between">
            <div class="text-start mb-2 lg:mr-2">
              <h6>
                <span>
                  {{ itin.no_of_days }}
                  {{ itin.no_of_days === 1 ? t('dashboard.day') : t('dashboard.days') }}
                  {{ t('dashboard.dayTour') }}
                  {{ itin.destination_name }} - {{ itin.full_name }}
                </span>
              </h6>
              <p class="text-sm">
                <span>{{ itin.creator | titlecase }}</span>
              </p>
              <p class="text-sm">
                {{ t('dashboard.createdAgo') }} {{ itineraryDateCalculation(itin.createdAt) }}
              </p>
            </div>
            <div class="flex gap-4">
              <button
                *appHasAnyPrivilege="'DASHBOARD.ITINERARY.EDIT'"
                [routerLink]="'/admin/itineraries/edit/' + itin._id"
                [disabled]="itin._id === '654cb18a609a7f7288f6cf03'"
                class="flex items-center justify-center gap-2"
                nz-button
                nzType="default">
                <span nz-icon nzType="edit"></span>
                {{ t('dashboard.edit') }}
              </button>
              <button
                (click)="this.onClickNavigateToPreview(itin)"
                nz-button
                class="flex items-center justify-center gap-2"
                nzType="primary">
                <span nz-icon nzType="eye"></span>
                {{ t('dashboard.preview') }}
              </button>
            </div>
          </div>
          <hr class="w-full my-4 opacity-20" />
        </div>
        <div *appHasAnyPrivilege="'ITINERARY.VIEW'" class="grid justify-center">
          <button
            nz-button
            nzType="default"
            [routerLink]="'/admin/itineraries'">
            {{ t('dashboard.showAll') }}
          </button>
        </div>
      </ng-container>
    </nz-card>

    <nz-card
      *appHasAnyPrivilege="'DASHBOARD.SALES.VIEW'"
      class="bg-slate-100 rounded-xl p-8">
      <h5 class="mb-12 text-primary">{{ t('dashboard.salesLeaderboard') }}</h5>

      <div *ngFor="let user of salesByUsers">
        <div class="flex items-center justify-between">
          <div>
            <h6>{{ user?.userName | titlecase }}</h6>
          </div>
          <div class="flex gap-6 items-center justify-between">
            <div class="text-center">
              <p class="text-sm">{{ t('dashboard.created') }}</p>
              <p class="text-sm font-bold">{{ user?.total }}</p>
            </div>
            <div class="text-center">
              <p class="text-sm">{{ t('dashboard.converted') }}</p>
              <p class="text-sm font-bold">{{ user?.saleConvert }}</p>
            </div>
          </div>
        </div>
        <hr class="w-full my-4 opacity-20" />
      </div>
    </nz-card>
  </div>
</section>
</ng-container>
